import React, { useState } from "react";
import { CustomerViewEditViewPrimaryInfoProps } from "./customer-view-edit-view-primary-info.props";
import { Box } from "@mui/material";
import { Formik, Form } from "formik";
import profileIcon from "../../../../../../assets/icons/profile.svg";
import {
  LEAD_SOURCE_OPTIONS,
} from "../../../../../../constants/leadDropdown";
import leadInfoIcon from "../../../../../../assets/icons/leadInfo.svg";
import {
  TextInputComponent,
  PhoneNumberComponent,
  SelectInputComponent,
  UploadImage,
} from "../../../../../../common/components";
import "./customer-view-edit-view-primary-info.scss";
import { useLeadOwnerOptions } from "../../../../../../utils/getLeadOwnerOptions";

const CustomerViewEditViewPrimaryInfo: React.FC<
  CustomerViewEditViewPrimaryInfoProps
> = (props: any) => {
  const { allLeadData, viewPrimaryInfoOpen, setViewPrimaryInfoOpen } = props;
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const initialValues = {
    title: "",
    company: "",
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    fax: "",
    website: "",
    numEmployees: "",
    annualRevenue: "",
    interestedProduct: "",
    socialLeadId: "",
    streetAddress: "",
    description: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    workPhone: {
      primaryPhoneNumber: "",
      primaryCountryCode: "+1",
      secondaryPhoneNumber: "",
      secondaryCountryCode: "+1",
    },
    imageUrl: "",
  };
  const LEAD_OWNER_OPTIONS = useLeadOwnerOptions();
  const [selectedInterestedProduct, setInterestedProduct] = useState([]);
  const [selectedLeadOwner, setSelectedLeadOwner] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("Manual");
  const [selectedLeadStatus, setSelectedLeadStatus] = useState("New Lead");
  const [selectedRating, setSelectedRating] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleCancel = async (values: any) =>
    setViewPrimaryInfoOpen(!viewPrimaryInfoOpen);
  const handleSave = async (values: any) => {
    try {
      const payload = {
        company: values.company,
        title: values.title,
        firstName: values.firstName,
        lastName: values.lastName,
        primaryEmail: values.email,
        secondaryEmail: values.secondaryEmail || null,
        primaryPhoneNumber:
          values.workPhone?.primaryCountryCode &&
          values.workPhone?.primaryPhoneNumber
            ? `${values.workPhone.primaryCountryCode}-${values.workPhone.primaryPhoneNumber}`
            : null,
        secondaryPhoneNumber:
          values.workPhone?.secondaryCountryCode &&
          values.workPhone?.secondaryPhoneNumber
            ? `${values.workPhone.secondaryCountryCode}-${values.workPhone.secondaryPhoneNumber}`
            : null,
        website: values.website || null,
        address: {
          street: values.streetAddress || null,
          city: values.city || null,
          state: values.state || null,
          country: values.country || null,
          zipcode: values.zipcode || null,
        },
        leadSource: selectedLeadSource || null,
        leadStatus: selectedLeadStatus || null,
        imageUrl: values.imageUrl || null,
        faxNumber: values.fax || null,
        industry: selectedIndustry || null,
        numberOfEmployees: values.numEmployees || null,
        annualRevenue: values.annualRevenue || null,
        interestedProducts:
          Array.isArray(selectedInterestedProduct) &&
          selectedInterestedProduct.length > 0
            ? selectedInterestedProduct.join(", ")
            : null,
        rating: selectedIndustry || null,
        socialLeadId: values.socialLeadId || null,
        description: values.description || null,
      };
      //   const response = await leadCreate(payload);
      //   if (response.data.success) {
      //     setAlertMessage("Lead saved successfully!");
      //     setAlertType("success");
      //     setAlertOpen(true);
      //     setTimeout(() => {
      //       navigate(routes.LEADLIST);
      //     }, 3000);
      //   } else {
      //     setAlertMessage("Failed to save lead.");
      //     setAlertType("error");
      //     setAlertOpen(true);
      //   }
    } catch (error) {
      // setAlertMessage("An error occurred while saving the lead.");
      // setAlertType("error");
      // setAlertOpen(true);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        handleSave(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <div className="customer-list-view-details-view-box-primary-info">
            <div className="customer-list-view-details-view-box-primary-info-profile">
              <div className="customer-list-view-details-view-box-primary-info-profile-pic">
                <UploadImage
                  label="Upload Photo"
                  text="logo"
                  value={values?.imageUrl}
                  onChange={(file: any) => {
                    setFieldValue("imageUrl", file);
                  }}
                />
              </div>
              <div className="customer-list-view-details-view-box-primary-info-profile-details">
                <div className="customer-list-view-details-view-box-primary-info-profile-details-name">
                  John Doe
                </div>
                <div className="customer-list-view-details-view-box-primary-info-profile-details-contact">
                  <span>
                    <i className="fa fa-phone" style={{ color: "#B4B4B4" }}></i>
                    &nbsp; +1-(545)677-6545
                  </span>
                  &nbsp;&nbsp;
                  <span style={{ borderLeft: "1px solid #B4B4B4" }}>
                    &nbsp;&nbsp;
                    <i
                      className="fa fa-envelope"
                      style={{ color: "#B4B4B4" }}
                    ></i>
                    &nbsp; john@gmail.com
                  </span>
                </div>
              </div>
            </div>

          </div>
          <Box className="footer">
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button type="submit" className="cancel-button next-button-wrapper">
              Save
            </button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default CustomerViewEditViewPrimaryInfo;
